export default __webpack_public_path__ + "static/media/recipients-info.7fac1f35.svg";